// import { useIsomorphicLayoutEffect } from "./use-isomorphic-layout-effect";
//
// const Storage = new Map<string, number>();
export const useScrollRestoration = (_key: string) => {
  // deprecated. the router's scroll restoration is used instead
  // useIsomorphicLayoutEffect(() => {
  //   if (Storage.has(key)) {
  //     window.scrollTo(0, Storage.get(key)!);
  //   } else {
  //     window.scrollTo(0, 0);
  //   }
  //   return () => {
  //     Storage.set(key, window.scrollY);
  //   };
  // }, [key]);
};
